/*
 * @Author: jiangxd
 * @Date: 2021-04-29 11:45:54
 * @LastEditTime: 2021-05-08 11:31:35
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/cornerDialog/index.tsx
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';

@DialogFactory
@Component({
  mixins: [style],
})
export default class cornerDialog extends IPSDialog {
  title = '角标预览';

  width = '580px';

  image = '';

  cancelText = '关闭';
  confirm = false;

  public left = null;
  public right = null;
  public bottom = null;

  public siteId = '';
  public productId = '';
  public tagId = '';
  public type = '';

  renderContent(h: CreateElement): VNode {
    return (
      <div class="dialog">
        <div class="box" style={{ backgroundImage: `url(${this.image})` }}>
          <div class="top">
            {this.left && (
              <div class="left">
                <el-image class="topimg" fit="fit" src={this.left.tagPic}></el-image>;
              </div>
            )}

            {this.right && (
              <div class="right">
                <el-image class="topimg" fit="fit" src={this.right.tagPic}></el-image>;
              </div>
            )}
          </div>
          {this.bottom && (
            <div class="bottom">
              <el-image class="topimg" fit="fit" src={this.bottom.tagPic}></el-image>;
            </div>
          )}
        </div>
      </div>
    );
  }
}
